import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { ReviewsWidget } from "@/components/sections/ReviewsWidget";
import { CTAGroup } from "@/components/CTAGroup";
import { BRAND, REVIEWS } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";
import { Star } from "lucide-react";

const ReviewsPage = () => {
  const avg = (REVIEWS.reduce((a, r) => a + r.rating, 0) / REVIEWS.length).toFixed(1);
  return (
    <Layout>
      <Seo
        title="Customer Reviews | VRP Flooring LLC — Danbury CT Flooring"
        description="Read reviews from homeowners and businesses across Danbury, Ridgefield, Bethel, Brookfield and Newtown who chose VRP Flooring LLC for their floors."
        jsonLd={[orgSchema(), breadcrumbSchema([{ name: "Home", url: BRAND.website }, { name: "Reviews", url: `${BRAND.website}/reviews` }])]}
      />
      <section className="container-page py-12 md:py-16">
        <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "Reviews" }]} />
        <div className="mt-6 max-w-3xl">
          <p className="eyebrow mb-4 text-accentInk">Client Reviews</p>
          <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">Trusted by Connecticut homeowners and businesses.</h1>
          <div className="flex items-center gap-3 text-lg">
            <div className="flex">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className="h-5 w-5 fill-accent text-accent" />)}</div>
            <span className="font-semibold">{avg} / 5</span>
            <span className="text-muted-foreground">based on client testimonials</span>
          </div>
        </div>
      </section>
      <section className="container-page pb-20"><ReviewsWidget /></section>
      <section className="bg-gradient-dark text-background py-20">
        <div className="container-page text-center max-w-2xl">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Become our next 5-star review.</h2>
          <CTAGroup variant="onDark" className="justify-center" />
        </div>
      </section>
    </Layout>
  );
};
export default ReviewsPage;
